import Competition from './PhotowallReducer';
import LocaleReducer from "./LocaleReducer";
import TrackingReducer from './TrackingReducer';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
    competition: Competition,
    locale:LocaleReducer,
    tracking: TrackingReducer,
});

export default rootReducer;
